import { Box, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

export const HeroSection = Box.withConfig({
  background: 'transparent',
  flexDirection: {
    base: 'column',
    md: 'row',
  },
});

export const ButtonsContainer = Box.withConfig({
  marginTop: {
    base: '$0',
    md: '$6',
  },
});

export const ActionButtonStyled = makeUclComponent(ActionButton).withConfig({
  minHeight: 50,
});
